import { LinearProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Flex } from '../../../../base/components/Flex';
import { useTranslationPrefix } from '../../../../hooks/useTranslationPrefix';
import QrButton from '../components/QrButton';
import QrPageLogo from '../components/QrPageLogo';

interface Props {
  onNext: () => void;
}

const seconds = 5;

const QrGoodByeStep = ({ onNext }: Props) => {
  const { _t } = useTranslationPrefix('LaunchPlaylistQrPageNew');

  const [waitState, setWaitState] = useState<{
    remaining: number;
    progress: number;
  }>({
    progress: 0,
    remaining: seconds,
  });

  const pastDue = waitState.remaining <= 0;
  useEffect(() => {
    const nextAt = seconds * 1000 + Date.now();
    const interval = setInterval(() => {
      const remaining = nextAt - Date.now();
      setWaitState({
        remaining: Math.max(0, Math.ceil(remaining / 1000)),
        progress: Math.max(0, Math.min(1, 1 - remaining / (seconds * 1000))),
      });
    }, 50);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pastDue) {
      onNext();
    }
  }, [pastDue]);

  return (
    <Flex
      flexDirection="column"
      width="100%"
      minHeight="100%"
      alignItems="center"
      justifyContent="space-evenly"
    >
      <Flex flexDirection="column" alignItems="center" gap={{ xs: 4, md: 8 }}>
        <QrPageLogo
          sx={{
            maxWidth: { md: '500px' },
            maxHeight: { md: '300px' },
            mx: 'auto',
          }}
        />

        <Flex flexDirection="column" gap={{ xs: 2, md: 3 }}>
          <Typography
            fontSize={{ xs: '2.25rem', md: '3rem' }}
            lineHeight="normal"
            fontWeight="300"
            textAlign="center"
          >
            {_t('thankYouForTraining', 'Than you for training with us.')}
          </Typography>
          <LinearProgress
            variant="determinate"
            color="success"
            value={waitState.progress * 100}
            sx={{ height: 8 }}
          />
          <Typography
            fontSize={{ xs: '2rem', md: '3rem' }}
            lineHeight="normal"
            fontWeight="300"
            textAlign="center"
          >
            <strong>{waitState.remaining}</strong> {_t('seconds', 's')}
          </Typography>

          <Flex justifyContent="center">
            <QrButton id="restart" onClick={onNext} color="success">
              {_t('newTraining', 'New training')}
            </QrButton>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default QrGoodByeStep;
